<div class="wrapper">
  <div class="heading">
    {{ heading }}
  </div>
  <!-- On a contractor-workflow project: Details / Discussion tabs; anywhere else the content as it is -->
  <app-issue-workflow-panel [issue]="data" [projectId]="data?.projectId">
  <div class="content">
    <div class="section description">
      {{ description }}
    </div>
    <div class="test-case-details">
      <div class="tester">
        <div class="tester-avatar">{{ testerAvatar }}</div>
        <div class="tester-name">{{ testerName }}</div>
      </div>
      <div class="test-time">{{ testTime }}</div>
    </div>
    <div class="details">
      <section class="section">
        <div class="section-heading">STATUS:</div>
        <div class="section-details">{{ data?.status }}</div>
      </section>
      <section class="section">
        <div class="section-heading">SCOPE:</div>
        <div class="section-details">{{ data?.entity?.description }}</div>
      </section>
      <section class="section">
        <div class="section-heading">INTERNAL:</div>
        <div class="section-details">{{ data?.internal ? 'Yes' : 'No' }}</div>
      </section>
      @if (data?.pictures?.length) {
        <section class="section">
          <app-attachments-block
            [pictures]="data?.pictures || []"
            />
        </section>
      }
    </div>
  </div>
  </app-issue-workflow-panel>
</div>
